import { forwardRef, ReactNode, useId } from "react";
import { classNames } from "../../support/formatters/class-formatter";
import { Radio } from "@webmotors/eleanor-ui";


type Spacings = "small" | "medium" | "large";

type Token =
  | 'primary'
  | 'default'
  | 'inactive'
  | 'active'
  | 'error'
  | 'warning'
  | 'complementary';
type LabelPlacement = 'start' | 'end';

export interface RadioButtonProps extends React.InputHTMLAttributes<HTMLInputElement>  {
  id?: string;
  label: string | ReactNode;
  token?: Token;
  labelPlacement?: LabelPlacement;
  className?: string;
  dataQA?: string;
  spacing?: Spacings;
  disabled?: boolean;
}

export const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(
  ({ id, label, token = "primary", labelPlacement = "end", className, dataQA, spacing = "small", disabled = false, ...props }, ref) => {
    const generatedId = useId();
    const finalId = id ?? generatedId;

    const containerClasses = classNames(className, spacing);

    return (
      <Radio
        id={finalId}
        label={label}
        token={token}
        labelPlacement={labelPlacement}
        className={containerClasses}
        ref={ref}
        disabled={disabled}
        {...props}
        data-qa={dataQA}
      />
    );
  }
);

export default RadioButton;
